import * as yup from 'yup';
import { FormPayload } from '../types';
import { FieldNames } from '../../../../Interfaces/Auth';

export const signUpSchema = yup.object<FormPayload>({
  [FieldNames.Password]: yup.string().required(),
  [FieldNames.Password2]: yup
    .string()
    .required()
    .oneOf([yup.ref(FieldNames.Password)], 'Passwords must match'),
});
